import {
  DocumentResponse,
  FullDocumentListResponse,
  GetDocumentRequest,
  LimitListDocumentsRequest,
} from 'src/common-services/types/document-types'
import { UserFile } from 'src/common-services/types/user-file-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class UserFilesClient extends BaseClient {
  listFiles(request: LimitListDocumentsRequest): Promise<FullDocumentListResponse> {
    return this.call<FullDocumentListResponse>('/files/', 'GET', {
      params: { limit: request.limit, offset: request.offset },
    })
  }

  getFile(request: GetDocumentRequest): Promise<DocumentResponse> {
    return this.call<DocumentResponse>(`/files/${encodeURIComponent(request.id)}`, 'GET')
  }

  updateFile(request: UserFile): Promise<DocumentResponse> {
    return this.call<DocumentResponse>(`/files/${encodeURIComponent(request.id)}`, 'PATCH', { data: request })
  }

  uploadFile(request: UserFile): Promise<string> {
    return this.call<string>(`/files/${encodeURIComponent(request.id)}`, 'POST', {
      data: request,
      formData: true,
    })
  }

  getDownloadUrl(documentId: string): string {
    return `/api/files/${encodeURIComponent(documentId)}/download`
  }

  getPreviewUrl(documentId: string): string {
    return `/api/files/${encodeURIComponent(documentId)}/preview`
  }

  getImageUrl(documentId: string): string {
    return `/api/files/${encodeURIComponent(documentId)}`
  }

  async downloadFile(request: GetDocumentRequest): Promise<any> {
    const output = await this.call(`/files/${encodeURIComponent(request.id)}/download`, 'GET', {
      responseType: 'blob',
    })
    return output
  }

  async downloadPreview(request: GetDocumentRequest): Promise<any> {
    const output = await this.call(`/files/${encodeURIComponent(request.id)}/preview`, 'GET', {
      responseType: 'blob',
    })
    return output
  }
}
